import { render, staticRenderFns } from "./StatsRunTime.vue?vue&type=template&id=2d2c662f&scoped=true&"
import script from "./StatsRunTime.vue?vue&type=script&lang=ts&"
export * from "./StatsRunTime.vue?vue&type=script&lang=ts&"
import style0 from "./StatsRunTime.vue?vue&type=style&index=0&id=2d2c662f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c662f",
  null
  
)

export default component.exports